import {GenericLinkedResource} from '@catcore/types/base';
import {ProjectFeature} from '@catmodules/models/project-feature/types';

export interface ActionItemState {
  isActive: boolean;
}

export interface DataTableCellInfo {
  label: string;
  value: any;
}

export interface DataTableItem {
  unit: DataTableCellInfo;
  feature: DataTableCellInfo;
  guiZone: DataTableCellInfo;
}

export interface FeatureForUnit {
  feature: ProjectFeature;
  guiZone: GenericLinkedResource;
}

export interface ProjectUnit {
  id: number;
  label: string;
  part_number: string;
  configurable: boolean;
  location_address: number;
  display_label?: string;
  update_group: number;
  pa_zone: number;
  name: string;
  _embedded?: any;
  _links: any;
}

export enum GuiZoneExplorerAction {
  create, info,
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/types.ts